import styled from 'styled-components';



export const SectionInformation = styled.section`
   background-color: ${({ theme }) => theme.color.white};
   padding: 30px 0px;
   
    @media ${({ theme }) => theme.screenSizes.tablet} {
      padding: 65px 92px 32px 92px;
    }
    @media ${({ theme }) => theme.screenSizes.laptop} {
      padding: 95px 132px 32px 132px;
    }

    button {
        border-radius: 30px;
        background: ${({ theme }) => theme.color.greenActions};
        color:${({ theme }) => theme.color.titleSection};
        font-family: "Work Sans";
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 171.429% */
        letter-spacing: -0.42px;
        height: 52px;
        width: 100%;
    }
    .separator {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 48px; /* Ajusta la altura del contenedor según tus necesidades */

    }

    .horizontal-line{
        width: 100%; /* Ajusta el ancho de la línea horizontal según tus necesidades */
        border: 0;
        border-top: 2px solid black; /* Ajusta el estilo según tus necesidades */
        opacity: 0.2;
        background: var(--colors-gray,${({ theme }) => theme.color.tableBenefis});
    }
    .show{
      display: block;
    }
    .hidden{
      display: none;
    }
`;
// Estilos para el contenedor de las pestañas
export const TabsContainer = styled.div`
  background-color: white;
  display: flex;
  justify-content: center;
    @media ${({ theme }) => theme.screenSizes.tablet} {
      justify-content: flex-end;
    }
    @media ${({ theme }) => theme.screenSizes.laptop} {
      justify-content: flex-end;
    }
`;

export const Title = styled.div`
    text-align: center;
      /* Title */
    font-family: "Antonia H3";
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 52px; /* 130% */
    letter-spacing: -1.2px;
    span {
        color: ${({ theme }) => theme.color.titleSection};
    }
    @media ${({ theme }) => theme.screenSizes.tablet} {
      text-align: left;
    }
    @media ${({ theme }) => theme.screenSizes.laptop} {
      text-align: left;
    }
`;

// Estilos para una pestaña individual
export const Tab = styled.div`
  padding: 10px 20px;
  cursor: pointer;
`;


// Estilos para una tarjeta individual
export const Card = styled.div`
  background: white;
  box-shadow: 0px 20px 26px 0px rgba(21, 31, 55, 0.10), 0px -2.17249px 9.77622px 0px rgba(21, 31, 55, 0.03);
  height: 430px;
  img {
    width: -webkit-fill-available;
    height: auto;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    max-height: 300px;
  }
  h2{
    padding: 25px 25px 0px 25px;
    /* SubTitle */
    color: #104B71;
    font-feature-settings: 'liga' off;
    /* H2 Regular */
    font-family: "Antonia H3";
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal; /* 140% */
    letter-spacing: -0.72px;
    text-align: left;
  }
  div {
    padding: 0px 25px 0px 25px;
    /* H2 Regular */
    font-family: "Work Sans";
    color: var(--Colors-Navy, #104B71);
    font-feature-settings: 'liga' off;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px; /* 140% */
    letter-spacing: -0.6px;
    text-align: left;
    a {
      color: var(--Morado-Brillante, #6065E0);
      font-feature-settings: 'liga' off;
      /* H2 Regular */
      font-family: Work Sans;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: -0.6px;
    }

    ul {
      list-style-type: disc; /* Utiliza disc para viñetas tipo punto */
      margin-left: 20px; /* Ajusta el margen izquierdo según tu preferencia */
    }
  }
  transition: box-shadow 0.2s;
  border-radius: 20px;
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;